import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Expand16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M9.94783 1.6087C9.94783 1.27252 10.2203 1 10.5565 1H14.3913C14.7275 1 15 1.27252 15 1.6087V5.44348C15 5.77965 14.7275 6.05217 14.3913 6.05217C14.0551 6.05217 13.7826 5.77965 13.7826 5.44348V3.07822L9.70867 7.15215C9.47096 7.38986 9.08556 7.38986 8.84785 7.15215C8.61014 6.91444 8.61014 6.52904 8.84785 6.29133L12.9218 2.21739H10.5565C10.2203 2.21739 9.94783 1.94487 9.94783 1.6087ZM7.15215 8.84785C7.38986 9.08556 7.38986 9.47096 7.15215 9.70867L3.07822 13.7826H5.44348C5.77965 13.7826 6.05217 14.0551 6.05217 14.3913C6.05217 14.7275 5.77965 15 5.44348 15H1.6087C1.27252 15 1 14.7275 1 14.3913V10.5565C1 10.2203 1.27252 9.94783 1.6087 9.94783C1.94487 9.94783 2.21739 10.2203 2.21739 10.5565V12.9218L6.29133 8.84785C6.52904 8.61014 6.91444 8.61014 7.15215 8.84785Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
